module.exports = "pegasus/assets/themelp1/small/25.png";